import React from 'react'
import * as sText from 'components/Text/Text.scss'
import * as sMarg from 'styles/modules/margins.scss'
import { Container } from 'components/Layout'
import cn from 'classnames'
import { PhoneSystemNumberEditForm } from '../PhoneSystemNumberEditForm'
import { INumberFormData } from '../PhoneSystemNumberEditForm/PhoneSystemNumberEditForm.container'

export interface IPhoneSystemNumberEditFormModalProps extends INumberFormData {
  modalCancel: () => undefined
  modalConfirm: () => undefined
}

export const PhoneSystemNumberEditFormModal = (props: IPhoneSystemNumberEditFormModalProps) => {
  const { modalConfirm, phoneSystemNumberId, customerReference, flowId } = props
  return (
    <Container paddingTop paddingBottom className="sm">
      <div style={{ margin: '0 30px' }}>
        <div className={cn(sText.descrip2, sText.center, sMarg.mb30)}>Edit Number:</div>
        <PhoneSystemNumberEditForm
          onAfterSubmit={modalConfirm}
          initialValues={{
            phoneSystemNumberId,
            customerReference,
            flowId,
          }}
        />
      </div>
    </Container>
  )
}



// WEBPACK FOOTER //
// src/features/PhoneSystem/PhoneSystemNumberEditFormModal/PhoneSystemNumberEditFormModal.tsx